import { I18n } from "@assets/strings";
import React, { useMemo } from "react";
import styled from "styled-components";
import { SubtitleSection } from "@domain/lms/article/article";

import { MaterialTextInput } from "@ui/components/inputs/materialTextInput";
import { useEditorController } from "@ui/pages/lms/article/articleEditorPage/articleEditorController/editorControllerContext";

interface SubtitleSectionEditorProps extends React.HTMLAttributes<HTMLDivElement> {
	section: SubtitleSection;
}

export const SubtitleSectionEditor: React.FC<SubtitleSectionEditorProps> = ({ section, ...htmlProps }) => {
	const artilcleController = useEditorController();
	const subtitleController = useMemo(() => artilcleController.subtitleSectionController(section), [section]);

	return (
		<StyledInput
			{...htmlProps}
			placeholder={I18n.t("article.editor.section.subtitle.placeholder")}
			value={section.title}
			onChange={(v) => subtitleController.setTitle(v)}
		/>
	);
};

const StyledInput = styled(MaterialTextInput)`
	input,
	input::placeholder {
		font-size: 1.25rem;
	}
`;
